import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';
import { BREAKPOINT_LARGER_MOBILE } from '../../organisms/SearchResults/lib/application.constants';

/* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */
export const StyledHotelCard = styled.div`
  ${rtl`
  /* CSS-reactive typography classes (mobile-first, desktop at lg breakpoint) */
  .card-subtitle-responsive {
    font-size: ${toRem(16)};
    line-height: ${toRem(20)};
    @media ${baseVariables.mediaQuery.lg} {
      font-size: ${toRem(22)};
      line-height: ${toRem(26)};
    }
  }
  /* Special case: xs on mobile/desktop, s on tablet only */
  .card-edge-case-responsive {
    font-size: ${toRem(12)};
    line-height: ${toRem(18)};
    @media ${theme.mediaQuery.allTablets} {
      font-size: ${toRem(14)};
      line-height: ${toRem(21)};
    }
  }

  @media only ${theme.mediaQuery.allTablets} ,${theme.mediaQuery.largerMobile} {
    .description-ellipsis {
      white-space: nowrap;
      overflow: hidden !important;
      text-overflow: ellipsis;
      width:44vw;
      display:block !important;
    }
  }
  .minicard-text-descriptor{
    color: ${baseVariables?.color?.neutral40}
  }
  .minicard-primary-title, .minicard-secondary-title {
    text-overflow: ellipsis;
    overflow:hidden;
    white-space: nowrap;
  }
  @media ${baseVariables.mediaQuery.md} {
    .minicard-primary-title, .minicard-secondary-title {
      width: ${toRem(300)} !important;
      text-overflow: ellipsis;
      overflow:hidden;
      white-space: nowrap;
    }
  }
  @media ${baseVariables.mediaQuery.lg} {
    .minicard-primary-title, .minicard-secondary-title {
      width: ${toRem(195)} !important;
      text-overflow: ellipsis;
      overflow:hidden;
      white-space: nowrap;
    }
  }

  .remove-info-icon{
    :after{
      content:none !important;
    }
  }
  .hotel-card-promo-label {
    position: relative;
    z-index: 7;
    width: fit-content;
    padding: ${toRem(4)};
    margin-left: ${toRem(4)};
    font-weight: bold;
    font-size: ${toRem(12)};
    letter-spacing: ${toRem(1.3)};
    background: ${theme.color['peach-orange']};
    display:block;
    border-radius: 0.25rem;
     @media only ${theme.mediaQuery.minDesktop} {
      margin-bottom:${toRem(4)};

     }
  }
  .hotel-card-promo{
    position:relative;
  }
  .mandate-fee-corner {
    @media only ${theme.mediaQuery.allMobiles} {
      .HotelCard__image {
        border-radius: ${toRem(14)} 0 0 0;
      }

      .hotel-card-text-section {
        border-radius: 0 ${toRem(14)} 0 0;
      }
    }

    @media only ${theme.mediaQuery.minDesktop} {
      .HotelCard__image {
        border-radius: ${toRem(14)} 0 0 0;
      }

      .hotel-card-text-section {
        border-radius: 0 ${toRem(14)} 0 0;
      }
    }
  }
  .mandatory-fee-section{
    display:flex;
    justify-content:flex-end;
    background-color:${theme.color.background};
    height:${toRem(29)};
    font-family: "Swiss-721";
    padding: 0 ${toRem(16)};
    border-radius: 0 0 ${toRem(14)} ${toRem(14)} !important;
  }
  .la-map-tooltip-adjustment {
    padding-left:0;
  }
  .custom-info{
    line-height:${toRem(16)};
    font-size:${toRem(12)};
    pointer-events:none;
  }
  .custom-info:after{
    pointer-events:all;
    height:${toRem(13.33)};
    width:${toRem(13.33)};
    padding-left: ${toRem(5)};
  }
  .custom-info:hover{
    background-color:transparent !important ;
    cursor: pointer !important ;
  }


  .HotelCard {
    height: 100%;
    width: ${toRem(332)};
    min-height: ${toRem(111)};
    &:focus-visible {
      outline: none;
    }

    .hotel-content {
      overflow: hidden;
      width: 100%;
      box-shadow: 0 0 ${toRem(8)} rgba(0, 0, 0, 0.15);
      border-radius: ${toRem(14)} !important;
      .image-section {
        min-height:${toRem(111)};
        border-bottom-left-radius: ${toRem(14)};
        .hqv-modal-opener {
          background: transparent;
          padding: 0;
        }
      }
    }
  }
  .image-section {
    width: ${toRem(120)};
    max-width: ${toRem(120)};
    background: ${theme.color.white};
    margin: 0 0 0 ${toRem(-1)};

    .image-gallery-component {
      height: ${toRem(240)};
      width: ${toRem(360)} !important;

      &.map-view-enabled .glide-wrap {
        .property-image {
          .property-image--img {
            height: ${toRem(240)};
            border-radius: ${toRem(14)} 0 0 ${toRem(14)};
          }
          .scrim-component {
            border-radius: 0 0 0 ${toRem(14)};
          }
        }

        .carousel .slider-wrapper {
          height: ${toRem(240)} !important;
        }
      }
    }
    
    .hide-img-gallery {
      display: none;
      @media (min-width: ${toRem(BREAKPOINT_LARGER_MOBILE)}) and (max-width:${toRem(992)}) {
      display: block;
      }
    }
  
    .hotel-brand-container {
      position: absolute;
      bottom: ${toRem(11)};
      left: ${toRem(17)};

      .brand-logo-XE::before {
        font-size: ${toRem(36.4)};
      }
      .brand-logo-MG::before {
        font-size: ${toRem(30)};
      }
      .brand-logo-SN::before {
        font-size: ${toRem(50)};
        margin-left: ${toRem(-10)};
      }
    }

    @media only ${theme.mediaQuery.smallerTablet},${theme.mediaQuery.largerMobile}  {
      height: ${toRem(240)};
      width: ${toRem(360)};
      flex: 1;
      max-width: ${toRem(360)};
      /* border-radius: ${toRem(14)} 0 0 ${toRem(14)}; */
      position: relative;
    }
  }
  .points-currency-label {
    margin-left: ${toRem(6)};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width:100%;
    @media ${baseVariables.mediaQuery.md} {
      max-width:${toRem(90)};
    }
    @media ${baseVariables.mediaQuery.lg} {
      max-width:100%;
    }
  }
  .hotel-card-text-section {
    width: calc(100% - ${toRem(120)});
    flex: 1;
    max-width: calc(100% - ${toRem(120)});
    min-width: calc(100% - ${toRem(119)});
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 0 ${toRem(14)} ${toRem(14)} 0;

    @media only ${theme.mediaQuery.smallerTablet},${theme.mediaQuery.largerMobile}  {
      height: ${toRem(240)};
      width: calc(100% - ${toRem(360)});
      max-width: calc(100% - ${toRem(360)});
      min-width: auto;
    }
  }

  .taxes-and-fees-corner {
    .hotel-card-text-section {
      border-radius: 0 ${toRem(14)} 0 0;
      @media only ${theme.mediaQuery.smallerTablet} {
        border-radius: 0 ${toRem(14)} ${toRem(14)} 0;
      }
    }
  }

  .close-btn {
    display: none;
  }

  .reviews-label {
    display: none;
  }

  .reviews-number{
    display: none;
  }

  .HotelCard .row {
    margin: 0;
    border-radius: ${toRem(14)} 0 0 0;
    @media only ${theme.mediaQuery.allTablets}{
      box-shadow: 0 4px 20px 0 rgba(0,0,0,0.07);
    }
    @media only ${theme.mediaQuery.allMobiles} {
      box-shadow: 0 4px 20px 0 rgba(0,0,0,0.2);
    }
    @media only ${theme.mediaQuery.allMobiles} {
      border-radius: ${toRem(14)};
    }
    @media only ${theme.mediaQuery.allTablets},${theme.mediaQuery.largerMobile}  {
      border-radius: ${toRem(14)};
    }
  }

  .HotelCard__image {
    border-radius: ${toRem(14)} ${toRem(0)} ${toRem(0)} ${toRem(14)};
    height: 100%;

    @media only ${theme.mediaQuery.smallerTablet},${theme.mediaQuery.largerMobile}  {
      border-radius: ${toRem(14)} ${toRem(0)} ${toRem(0)} ${toRem(14)};
    }

    @media only ${theme.mediaQuery.mobileOnly} {
      border-radius: ${toRem(14)} ${toRem(0)} ${toRem(0)} ${toRem(0)};
    }
  }
  .unavailable-image-fallback {
    position: relative;
    .image-unavailable-text {
      position: absolute;
      top: 50%;
      left: 5%;
    }
  }

  .HotelCard__top-section {
    padding: ${toRem(10)} ${toRem(4)} 0 ${toRem(10)};
    width:auto;
    @media ${baseVariables.mediaQuery.md} {
      width:fit-content;
    }
  }

  .HotelCard__top-section_title-section:hover {
    text-decoration: none;
  }

  .HotelCard__top-section_title {
    margin-bottom: ${toRem(4)};
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    .HotelCard__top-section_title-section {
      background: ${theme.color['white']};
      text-align:left;
    }
    @media only ${theme.mediaQuery.allMobiles} {
      line-height: ${theme.fonts['lineHeightM']};
    }

    @media only ${theme.mediaQuery.minDesktop} {
      line-height: ${theme.fonts['lineHeightM']};
    }

    &.name-ellipsis{
      overflow: hidden !important;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      @media only ${theme.mediaQuery.minDesktop} {
        -webkit-line-clamp: 1;
        }
      @media only ${theme.mediaQuery.allMobiles} {
        -webkit-line-clamp: 1;
      }
    }
  }

  .HotelCard__top-section_reviewsAndDistance {
    display: flex;
    padding-bottom: 0;
    align-items: center;
    .hqv-modal-opener {
      background: transparent;
    }

    @media only ${theme.mediaQuery.smallerTablet},${theme.mediaQuery.largerMobile}  {
      padding-bottom: ${toRem(7)};
    }
  }
  
  .hotel-card-all-inclusive-tag{
    height: ${toRem(16)};
    border-radius: ${toRem(4)};
    background: ${theme.color['dark-gray-4']};
    letter-spacing: ${toRem(1.2)};
    text-transform: uppercase;
    width: fit-content;
    white-space: nowrap;
    margin-right: ${toRem(8)};
  }

  .divider-section {
    display: none;
  }

  .HotelCard__top-section_distance {
    display: none; /* Hidden on mobile */
    flex-shrink: 1; /* Now this works because parent is flex */
    min-width: 0; /* Critical for flex child truncation */
    
    .m-icon-text {
      display: flex;
      align-items: center;
      min-width: 0; /* Critical: allows text to shrink below content size */
      width: 100%; /* Take full width of the flex item */
      
      /* Target the text span specifically - REMOVE white-space: nowrap */
      span:not(.icon-alt) {
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1; /* Take remaining space after icon */
        min-width: 0; /* Critical for text truncation */
      }
      
      /* Keep icon fixed size */
      .icon-alt {
        flex-shrink: 0; /* Don't let icon shrink */
      }
    }
  }

  .HotelCard__mid-section {
    display: none;
  }
  .no-line {
    border-top:0 !important;
  }
  .hotel-card-max-occ-height {
    margin: ${toRem(4)} 0 ${toRem(3)} ${toRem(24)};
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
  .edit-rates-label{
    @media ${baseVariables.mediaQuery.lg} {
      line-height: ${baseVariables.font.lineHeightS}
    }
  }
  .HotelCard__bottom-section {
    border-top: ${toRem(1)} solid lightgray;
    padding: ${toRem(3)} ${toRem(16)};
    text-align: right;

    @media only ${theme.mediaQuery.smallerTablet},${theme.mediaQuery.largerMobile}  {
      padding-top: ${toRem(9)};
      padding-top: ${toRem(9)};
    }

    @media only ${theme.mediaQuery.minDesktop} {
      display:flex;
      align-items:center;
      justify-content:flex-end;
    }
  }
  .adult-only {
    padding: ${toRem(3)} ${toRem(8)};
  }
  .hotel-card-unavilable{
    padding: ${toRem(4)} ${toRem(10)};
    text-align: right;
    border-top: ${toRem(1)} solid lightgray;

    @media only ${theme.mediaQuery.minDesktop} {
      display:flex;
      align-items:center;
      justify-content:flex-end;
    }
  }
  .edit-guest {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: right;
    padding-left: ${toRem(48)};
    @media only ${theme.mediaQuery.minDesktop} {
      display: none;
    }
    @media only ${theme.mediaQuery.allMobiles} {
      display: none;
    }
  }
  .price-section {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
  }
  .include-tax-section{
    display:flex;
    justify-content:flex-end;
    background-color: ${theme.color.background};
    height:${toRem(29)};
    padding-top:${toRem(5)};
    padding-bottom:${toRem(11)};
    padding-right:${toRem(16)};
    font-family: "Swiss721-BT-Regular";
    border-radius: 0 0 ${toRem(14)} ${toRem(14)};
  }
  .taxes-and-fees-included{
    font-family: "Swiss-721";
  }

  .view-rates-button {
    display: none;
  }

  .show-availability-button {
    display: none;
  }

  .view-rates-button .currency-section {
    display: none;
  }

  .points-saver-label {
    display: none;
  }

  .points-value.points-saver {
    color: ${theme.color['verdun-green']};
  }

  .points-section {
    &.points-saver {
      .points-currency-label {
        color: ${theme.color['black']};
      }
      .currency-section {
        display: none !important;
        @media only ${theme.mediaQuery.allTablets},${theme.mediaQuery.largerMobile}  {
          display: flex !important;
          margin-top: ${toRem(-6)};
        }
      }
    }

    &.non-saver {
      .currency-section {
        display: none !important;
        @media only ${theme.mediaQuery.allTablets},${theme.mediaQuery.largerMobile}  {
          display: flex !important;
        }
      }
    }

    .currency-section {
      display: none !important;
      @media only ${theme.mediaQuery.allTablets},${theme.mediaQuery.largerMobile}  {
          display: flex !important;
        }
    }
  }

  .adult-only-message {
    display: none;
  }

  .call-to-book {
    text-align: right;

    @media only ${theme.mediaQuery.allTablets},${theme.mediaQuery.largerMobile}  {
      padding: ${toRem(7)} 0;
    }
  }

  .unavailable-text {
    text-align: right;
  }

  .opening-soon {
    text-align: right;
    line-height: ${toRem(18)};
    white-space: normal;
    overflow-wrap: break-word;
    @media only ${theme.mediaQuery.smallerTablet},${theme.mediaQuery.largerMobile}  {
      display: flex;
     justify-content: flex-end;
     align-items: baseline;
     .view-availablity {
       margin-left:${toRem(16)};
     }
   }
   @media only ${theme.mediaQuery.minDesktop} {
      padding: ${toRem(4)} 0 ${toRem(3)};
    }

    @media only ${theme.mediaQuery.allMobiles} {
      padding: ${toRem(4)} 0 ${toRem(3)};
    }
  }

  .gm-style .gm-style-iw-t:after {
    height: ${toRem(10)};
    width: ${toRem(10)};
  }

  .m-ratings:hover {
    text-decoration:underline;
  }

  .gm-style-cc {
    display:none;
  }

  .close-icon {
width:${toRem(16)};
height:${toRem(16)};
  }

  @media only ${theme.mediaQuery.smallerTablet},${theme.mediaQuery.largerMobile}  {
    .includes-fee{
      display:flex;
      justify-content:flex-end;
      margin-right: 0;
    }
    .custom-info-map{
      font-size:${toRem(12)};
      display:flex;
      justify-content : flex-end;
      padding: 0 !important;
      margin-left: ${toRem(1)};
      pointer-events:none;
    }
    .custom-info-map:after{
      height:${toRem(13.04)};
      width:${toRem(13.04)};
      margin-right:${toRem(2)};
      pointer-events:all;
    }
    .m-link-icon-button-info:hover{
      background-color:transparent !important ;
      cursor: pointer !important ;
    }
    .price-sub-section{
    display:block;
  }
  .mandatory-fee-section-list-view{
      font-size:${toRem(12)};
      font-family: "Swiss-721";
      line-height:${toRem(16)};
      color: ${theme.color['dark-gray-14']}
    }
    .mandatory-fee-section-list-view > div:last-child{
      margin-left: ${toRem(2)};
    }
    .mandatory-fee-label-text{
      display: inline-block;
      margin-left: ${toRem(3)};
    }
    .mandatory-fee-section{
      font-family: "Swiss-721";
      display:flex;
      justify-content:flex-end;
      background-color: ${theme.color.background};
      height:${toRem(29)};
      background-color:transparent;
      padding: 0 ${toRem(16)};
    }
    .m-r-15{
      margin-right:${toRem(24)};
    }
     .reviews-label {
      display:block;
      margin-left:${toRem(3)};

    }

    .star-reviews-container {
      display: flex;
    }

    .gm-style-iw.gm-style-iw-c {
      max-width: unset !important;
      position: fixed !important;
      top: 46vh !important;
      width: 93vw;
    }
    .gm-style-iw-t:after {
      background: none !important;
    }
    .gm-style .gm-style-iw-t:after {
      background: none !important;
      box-shadow: none !important;
    }
    .HotelCard {
      min-height: 239px;
      min-width: 91vw;
    }
    .HotelCard .second-card-close {
      display: none;
    }
    .Second-Card {

      bottom:${toRem(205)} ;

    }
    .hotel-content {
      background: white;
      .brand-logo-WH::before {
        font-size: ${toRem(16)};
      }

      .hotel-card-text-section {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
    .hotel-card-promo{
      position:relative;
    }
    .hotel-card-promo-label {
      position: absolute;
      z-index: 7;
      width: fit-content;
      padding: ${toRem(4)};
      margin-left: ${toRem(4)};
      font-weight: bold;
      margin-top: ${toRem(8)};
      font-size: ${toRem(18)};
      background: ${theme.color['peach-orange']};
      display:block;
      border-radius: 0.25rem;
    }
    .close-btn {
      display: block;
      position: absolute;
      z-index: 10;
      background: ${theme.color['black']};
      color: ${theme.color.white} !important;
      opacity: 0.54;
      right: 0;
      width:${toRem(46)};
      height:${toRem(46)};
      top: ${toRem(-50)};
      border-radius:${toRem(6)};
    }

    .HotelCard__top-section {
      padding: ${toRem(12)} ${toRem(13)} 0 ${toRem(24)};
    }

    .HotelCard__top-section_title {
      margin-bottom: ${toRem(6)};
      display: block;
    }

    .HotelCard__mid-section {
      display: block;
      padding: 0 ${toRem(13)} 0 ${toRem(24)};
    }

    .HotelCard__mid-section_description {
      margin: 0 0 ${toRem(8)};
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    .HotelCard__mid-section_details {
      padding: ${toRem(4)} 0 0;
      background: transparent;
    }

    .HotelCard__mid-section_details:hover {
      text-decoration: underline;
    }

    .divider-section {
      display: block;
    }

    .HotelCard__top-section_distance {
      display: flex; /* Changed from block to flex to maintain flex relationship */
      }
      .with-all-inclusive{
        flex-shrink: 1; /* Now this will work! */
        white-space: nowrap; /* to maintaine text in single line */
        max-width: ${toRem(130)}; /* Critical for flex child truncation */
      }

    .HotelCard__bottom-section {
      border-top: ${toRem(1)} solid lightgray;
      padding: ${toRem(8)} ${toRem(16)} ${toRem(8)} ${toRem(10)};
      text-align: right;
    }

    .price-container {
             display: flex;
              flex-direction: row;
              justify-content: flex-end;
              align-items: center;
              margin-top: 0;
          .view-rates-button-container {
            margin-left: ${toRem(24)};
          }
          .rate-container {
            justify-content: flex-end;
            display: flex;
            flex-direction: row;
            align-items: baseline;
            overflow: hidden;
          }
    }
    .price-value-section{
      margin-left: auto;
    }
    .taxes-and-fees-included {
      font-family: "Swiss-721";
      display: block;
      margin-left: auto;
    }
    // Point Saver with Taxes & Fees left-alignment for tablet map view
    .points-section.points-saver:has(.taxes-and-fees-included) {
      .currency-section {
        align-items: flex-start;
        .price-value-section {
          margin-left: 0;
        }
        .taxes-and-fees-included {
          margin-left: 0;
        }
      }
    }
    .view-rates-button {
      display: flex;
      align-items: center;
      padding-left: ${toRem(31)};
      padding-right: ${toRem(31)};
    }

    .show-availability-button {
      border: ${toRem(2)} solid ${theme.color['cod-grey']};
      display: flex;
      align-items: center;
      &:focus {
                outline: none;
              }
    }

    .currency-section {
      display: flex;
      align-items: center;
    }

    .points-section {
      &.points-saver {
        .points-currency-label {
          color: ${theme.color['black']};
        }
        .currency-section {
          display: flex;
        }
      }

      &.non-saver {
        .currency-section {
          display: flex;
        }
      }
    }

    .points-saver-label {
      display: block;
      text-align: left;
      margin-bottom: ${toRem(-7)}
    }

    .hotel-unavailable {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    .adult-only-message {
      display: inline;
    }
    .adult-only-message-for-desktop {
      display: inline;
    }
  }

  @media only ${theme.mediaQuery.allMobiles} {
     .HotelCard {
      width:87vw;
      border-radius: ${toRem(-10)};
      height: fit-content;
    }
    .HotelCard:has(.mandatory-fee-section){
      margin-bottom: unset;
    }
    .mandatory-fee-section{
      font-family: "Swiss-721";
      border-radius: 0 0 ${toRem(14)} ${toRem(14)} !important;
    }
     .HotelCard__top-section_title {
       height: auto;
    }
   .HotelCard__top-section_reviewsAndDistance {
    width:fit-content;
  }
    .m-r-15{
      margin-right:1.5rem;
    }

     .reviews-label {
      display: none;
    }
    
    .reviews-number{
      display: none;
    }

    .gm-style-iw.gm-style-iw-c {
      max-width: unset !important;
      position: fixed !important;
      top: 46vh !important;
      width: 93vw;
    }

    .gm-style-iw-t:after {
      background: none !important;
    }

    .gm-style .gm-style-iw-t:after {
      background: none !important;
      box-shadow: none !important;
    }

    .HotelCard .second-card-close {
      display: none;
    }

    .Second-Card {
      bottom: 23%;
    }
    .Second-card-with-badge {
      bottom:30%;
    }
    .hotel-content {
      background: white;
      .hotel-card-text-section {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
    .hotel-card-promo{
      border-radius: 0.125rem;
    }
    .hotel-card-no-promo-mob{
      height: 1.5625rem;
      margin-bottom:0.6rem;
    }
    @media only ${theme.mediaQuery.largerMobile} {
      .hotel-card-no-promo-mobil {
        height: 1.5625rem;
        margin-bottom:0.6rem;
      }
    }
    .hotel-card-promo-label {
      display:block;
      z-index: 7;
      width: max-content;
      padding: ${toRem(4)} ${toRem(10)};
      background: ${theme.color['peach-orange']};
      border-radius: 0.25rem;
      letter-spacing: ${toRem(1.3)};
    }

    .close-btn {
      display: block;
      position: absolute;
      z-index: 10;
      background: ${theme.color['black']};
      color: ${theme.color.white} !important;
      opacity: 0.54;
      right: 0;

      width:${toRem(46)};
      height:${toRem(46)};
      top: ${toRem(-50)};
      border-radius:${toRem(6)};
    }

  }

  @media only screen and (max-width: 380px) {

    .HotelCard {
      height: 100%;
      width: 87vw;
      min-height: ${toRem(111)};

      &.Second-Card {
        bottom: 31.5%;

      }
    }
  }

  .adult-only-message-for-desktop {
    display: none;

    @media only ${theme.mediaQuery.allTablets} {
      display: block;
    }
  }

  .remove-children-message {
    display: block;

    @media only ${theme.mediaQuery.allTablets} {
      display: none;
    }
  }
  `}
  .m-ratings.is-review-count-hidden {
    &:hover {
      text-decoration: none;
    }
  }

  /* Chat-specific styles for mobile map view */
  .chat-hotel-card {
    width: ${toRem(343)} !important;
    min-width: ${toRem(343)} !important;
    min-height: auto !important;
    padding: ${toRem(8)} !important;
    background: ${theme.color.white};
    border-radius: ${toRem(16)} !important;
    box-shadow: 0 ${toRem(7)} ${toRem(20)} 0 rgba(0, 0, 0, 0.25);

    .hotel-card-no-promo-mob,
    .hotel-card-no-promo-mobil,
    .hotel-card-promo {
      display: none !important;
    }

    .hotel-content {
      border-radius: ${toRem(16)} !important;
      box-shadow: none !important;
    }

    .image-section {
      width: ${toRem(104)} !important;
      max-width: ${toRem(104)} !important;
      min-height: ${toRem(104)} !important;
      height: ${toRem(104)} !important;
      flex: 0 0 ${toRem(104)} !important;
      border-radius: ${toRem(8)} !important;
      overflow: hidden;

      .image-gallery-component {
        height: ${toRem(104)} !important;
        width: ${toRem(104)} !important;

        &.map-view-enabled .glide-wrap {
          .property-image {
            .property-image--img {
              height: ${toRem(104)} !important;
              border-radius: ${toRem(8)} !important;
            }
            .scrim-component {
              border-radius: 0 0 0 ${toRem(8)} !important;
            }
          }

          .carousel .slider-wrapper {
            height: ${toRem(104)} !important;
          }
        }
      }

      .HotelCard__image {
        border-radius: ${toRem(8)} !important;
        height: ${toRem(104)} !important;
        width: ${toRem(104)} !important;
        object-fit: cover;
      }

      .hotel-brand-container {
        display: none !important;
      }
    }

    .hotel-card-text-section {
      width: calc(100% - ${toRem(104)}) !important;
      max-width: calc(100% - ${toRem(104)}) !important;
      min-width: calc(100% - ${toRem(104)}) !important;
      height: ${toRem(104)} !important;
      padding-left: ${toRem(16)} !important;
      padding-right: ${toRem(8)} !important;
      border-radius: 0 !important;
      display: flex;
      flex-direction: column;
      justify-content: center !important;
      gap: ${toRem(4)};
    }

    .HotelCard__top-section {
      padding: 0 !important;
      width: 100% !important;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .HotelCard__top-section_title {
      margin-bottom: ${toRem(4)} !important;
      -webkit-line-clamp: 2 !important;
      overflow: visible !important;
      text-overflow: unset !important;
      white-space: normal !important;
      display: block !important;

      .HotelCard__top-section_title-section {
        font-family: 'Swiss721 BT', 'Swiss-721', sans-serif !important;
        font-size: ${toRem(16)} !important;
        font-weight: 500 !important;
        line-height: 1.25 !important;
        color: ${theme.color['cod-grey']} !important;
        display: -webkit-box !important;
        -webkit-box-orient: vertical !important;
        -webkit-line-clamp: 2 !important;
        overflow: hidden !important;
      }
    }

    .HotelCard__top-section_reviewsAndDistance {
      padding-bottom: 0 !important;
      flex-wrap: wrap;
      gap: ${toRem(8)};

      .m-ratings {
        font-family: 'Swiss721 BT', 'Swiss-721', sans-serif !important;
        font-size: ${toRem(12)} !important;
        line-height: 1.5 !important;
        color: ${baseVariables?.color?.neutral40} !important;
      }

      .reviews-label {
        display: inline !important;
        margin-left: 0 !important;
      }

      .reviews-number {
        display: inline !important;
      }
    }

    .HotelCard__top-section_distance {
      display: none !important;
    }

    .divider-section {
      display: none !important;
    }

    .HotelCard__mid-section {
      display: none !important;
    }

    .HotelCard__bottom-section,
    .hotel-card-unavilable {
      border-top: ${toRem(1)} solid ${baseVariables?.color?.neutral20 || '#eeeeee'} !important;
      padding: ${toRem(8)} 0 0 0 !important;
      margin-top: 0 !important;
      text-align: left !important;
      justify-content: space-between !important;
      align-items: center !important;
      display: flex !important;
      flex-direction: row !important;
      height: ${toRem(40)} !important;
      position: relative;

      .price-container {
        display: flex !important;
        justify-content: space-between !important;
        flex-direction: row !important;
        align-items: center !important;
        flex: 1;
        width: 100% !important;
      }

      .price-sub-section {
        display: flex !important;
        flex-direction: row !important;
        align-items: baseline !important;
        flex: 1;
      }

      .price-section {
        justify-content: flex-start !important;
      }

      .price-value {
        font-family: 'Swiss721 BT', 'Swiss-721', sans-serif !important;
        font-size: ${toRem(22)} !important;
        font-weight: 500 !important;
        line-height: 1.25 !important;
        color: ${theme.color['cod-grey']} !important;
      }

      .price-label,
      .currency-label {
        font-family: 'Swiss721 BT', 'Swiss-721', sans-serif !important;
        font-size: ${toRem(12)} !important;
        font-weight: 500 !important;
        line-height: 1 !important;
        color: ${baseVariables?.color?.neutral40} !important;
        margin-left: ${toRem(8)} !important;
      }

      .view-rates-button-container,
      .view-rates-button {
        display: none !important;
      }

      /* Chat arrow icon styling */
      .chat-arrow-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${toRem(32)};
        height: ${toRem(32)};
        font-size: ${toRem(24)} !important;
        color: ${theme.color['cod-grey']} !important;
        flex-shrink: 0;
      }
    }

    .close-btn {
      display: none !important;
    }

    .hotel-card-all-inclusive-tag {
      display: none !important;
    }
  }
`;
